import { Dropdown, Popover } from '@digdir/designsystemet-react';
import { FC, useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, EnvelopeClosedIcon, LinkIcon } from '@navikt/aksel-icons';
import { useTranslation } from 'react-i18next';

import { StyledDropdownButton } from './styledComponents';

interface Props {
  attestUrl: string;
}

export const ShareButton: FC<Props> = ({ attestUrl }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [popoverOpen, setPopoverOpen] = useState(false);

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(attestUrl);
    setPopoverOpen(true);
    setOpen(false);
  };

  const handleEmailClick = () => {
    const subject = t('energiattestPage.email.subject');
    const body = t('energiattestPage.email.body', { url: attestUrl });
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setOpen(false);
  };

  return (
    <Dropdown.TriggerContext>
      <Popover open={popoverOpen}>{t('energiattestPage.clipboardCopySuccess')}</Popover>

      <Dropdown.Trigger variant="secondary" onClick={() => setOpen(!open)}>
        {t('energiattestPage.buttons.share')}
        {open ? <ChevronUpIcon aria-hidden /> : <ChevronDownIcon aria-hidden />}
      </Dropdown.Trigger>

      <Dropdown open={open} onClose={() => setOpen(false)}>
        <Dropdown.Item>
          <StyledDropdownButton onClick={copyToClipboard}>
            <LinkIcon aria-hidden />
            {t('energiattestPage.buttons.copyToClipboard')}
          </StyledDropdownButton>
        </Dropdown.Item>
        <Dropdown.Item>
          <StyledDropdownButton onClick={handleEmailClick}>
            <EnvelopeClosedIcon aria-hidden />
            {t('energiattestPage.buttons.shareByEmail')}
          </StyledDropdownButton>
        </Dropdown.Item>
      </Dropdown>
    </Dropdown.TriggerContext>
  );
};
